export default "__VITE_ASSET__CBfSIADh__"